import { render, staticRenderFns } from "./BcTabs.vue?vue&type=template&id=64f60952"
import script from "./BcTabs.vue?vue&type=script&lang=js"
export * from "./BcTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports